import { useTheme } from '@mui/material';
import { MdDragIndicator } from '@teamworksdev/icons';
import { CSS } from '@dnd-kit/utilities';
import React from 'react';
import { CELL_CLASSNAME_SELECTED } from '../../../components/sheet';
import { cn } from '../../../components/utils';
import { WorkoutSectionDraggable, useDndRow, DROPPABLE_CLASSNAME } from '../dnd';
import { blockSectionAndExerciseLabelStyle } from './common';

export type DndRowState = ReturnType<typeof useDndRow<WorkoutSectionDraggable>>;

export const DraggableLabelWrapper = ({
  dndState,
  ariaLabel,
  labelPadding = 'px-0',
  droppablePadding,
  children,
  dragOverlayChildren,
}: {
  dndState: DndRowState;
  ariaLabel: string;
  labelPadding?: string;
  droppablePadding?: string;
  children: React.ReactNode;
  dragOverlayChildren: React.ReactNode;
}) => {
  const { palette: { greyscaleLight } } = useTheme();
  const {
    showDragIcon, highlight, isDragging, transform,
    setDraggableRef, setActivatorNodeRef, setDroppableRef,
    listeners, attributes, setHovering,
  } = dndState;

  return (
    <div className="relative h-full w-full">
      <div
        onMouseEnter={() => setHovering(true)}
        onMouseLeave={() => setHovering(false)}
        ref={setDraggableRef}
        className={cn(blockSectionAndExerciseLabelStyle, labelPadding)}
      >
        {showDragIcon && (
          <div
            className="mr-1"
            {...listeners}
            {...attributes}
            ref={setActivatorNodeRef}
            aria-label={ariaLabel}
          >
            <MdDragIndicator size={18} color={greyscaleLight[400]} />
          </div>
        )}
        {children}
      </div>

      {isDragging && (
        <div
          className={`${CELL_CLASSNAME_SELECTED} absolute top-0 left-0 z-30 flex h-full w-full items-center bg-white`}
          style={{ transform: CSS.Translate.toString(transform) }}
        >
          <MdDragIndicator className="mr-1" size={18} color={greyscaleLight[400]} />
          {dragOverlayChildren}
        </div>
      )}

      <div
        className={cn(
          'absolute top-0 left-0 h-full w-full',
          droppablePadding,
          highlight && DROPPABLE_CLASSNAME,
        )}
        ref={setDroppableRef}
      />
    </div>
  );
};
